import { Component, OnInit, Injectable } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return super.format(date, displayFormat);
  }
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-of-return-cell',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
  template: `
    <div class="date-of-return-cell">
      <mat-form-field appearance="outline" class="date-field" id="dateOfReturnField">
        <input
          matInput
          [matDatepicker]="picker"
          [(ngModel)]="selectedDate"
          (dateChange)="onDateChange()"
          placeholder="YYYY-MM-DD"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  `,
  styles: [
    `
       ::ng-deep #dateOfReturnField .mat-mdc-text-field-wrapper {
        border: none !important;
      }
        ::ng-deep #dateOfReturnField .mat-mdc-form-field-input-control {
        width: 85px;
        font-size: 14px;
        padding-left: 8px;
      }
        ::ng-deep #dateOfReturnField .mat-mdc-form-field-infix {
        width: 80px !important;
      }
    `,
  ],
})
export class DateOfReturnCellComponent implements ICellRendererAngularComp {
  selectedDate: Date | null = null;
  private params: any;

  agInit(params: any): void {
    this.params = params;
    if (params.value) {
      this.selectedDate = new Date(params.value);
    }
  }

  refresh(params: any): boolean {
    this.params = params;
    if (params.value) {
      this.selectedDate = new Date(params.value);
    }
    return true;
  }

  onDateChange(): void {
    if (!this.selectedDate || !this.params?.data?.id) {
      return;
    }

    const dateValue = this.formatDate(this.selectedDate);
    const recordId = this.params.data.id;
    const employeeId = this.params.data.employeeId;

    // Call the global handler
    if ((window as any).onDateOfReturnChange) {
      (window as any).onDateOfReturnChange(recordId, employeeId, dateValue);
    }
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
